import type { AboutCopy } from '../types/about';

export const aboutEn: AboutCopy = {
  seo: {
    title: 'About us',
    description:
      'SafestMenu is built and operated by transfactor.dev, a senior software team in Bucharest, Romania - ISO 9001 and ISO/IEC 27001 certified.',
  },
  hero: {
    eyebrow: 'About us',
    heading:
      'Made by people who build software for a living - and eat out a lot.',
  },
  story: {
    intro:
      'SafestMenu started with a simple observation: paper menus are expensive to reprint, impossible to keep current, handled by hundreds of guests, and thrown away by the stack. Every restaurant we talked to had the same problem - and no time for a complicated solution.',
    easyIntro:
      'So we built the menu we would want in our own restaurant: one you set up in minutes, update from your phone, and never print again. ',
    easyHighlight: 'Easy to use',
    easyOutro: ' was not a feature on a list - it was the whole point.',
    imageAlt: 'A SafestMenu QR code table card on a cafe table next to an espresso',
  },
  team: {
    heading: 'The team behind it',
    linkIntro: 'SafestMenu is built and operated by ',
    linkText: 'transfactor.dev',
    linkOutro:
      ', a senior software team based in Bucharest, Romania. transfactor.dev designs, builds and ships web products, AI systems and internal tools - over twenty shipped products and eighteen years of combined experience, working ISO 9001 and ISO/IEC 27001 certified.',
    reliability:
      'That matters for you in one concrete way: SafestMenu is not a side project that disappears next year. It is maintained, secured and improved by the same team, every week.',
  },
  beliefs: {
    heading: 'What we believe',
    items: [
      'Software for restaurants should be simpler than running a restaurant.',
      'Guests deserve honest menus: clear prices, real photos, allergens marked.',
      'Less paper in the bin is good for everyone - your budget included.',
    ],
  },
  cta: {
    label: 'Try SafestMenu free',
  },
};
